import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material';
import { Subscription } from 'rxjs';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { MatCard } from '@angular/material/card';

@Component({
    selector: 'app-ffurflen-gwirio',
    templateUrl: './ffurflen-gwirio.component.html',
    styleUrls: ['./ffurflen-gwirio.component.scss'],
    imports: [MatCard, FormlyModule]
})
export class FfurflenGwirioComponent extends FieldType<FieldTypeConfig> implements OnInit {

  desktop = false;

  watcher: Subscription;

  constructor() {
    super();

    // // https://www.npmjs.com/package/ngx-device-detector
    // const isTablet = this.deviceService.isTablet();

    // if (isTablet) {
    //   this.desktop = false;
    // }
    // else {
    //   this.watcher = mediaObserver.asObservable().pipe(
    //     filter((changes: MediaChange[]) => changes.length > 0),
    //     map((changes: MediaChange[]) => changes[0])
    //   ).subscribe((change: MediaChange) => {
    //     if (change.mqAlias === 'sm' || change.mqAlias === 'xs') {
    //       this.desktop = false;
    //     } else {
    //       this.desktop = true;
    //     }
    //   });
    // }
  }

  ngOnInit(): void {

  }
}